import { createId } from '../utils/format'

export default function AdditionalSpecsEditor({ rows, onChange }) {
  function updateRow(id, field, value) {
    onChange(rows.map((row) => (row.id === id ? { ...row, [field]: value } : row)))
  }

  function addRow() {
    onChange([...rows, { id: createId('spec'), key: '', value: '' }])
  }

  function removeRow(id) {
    onChange(rows.filter((row) => row.id !== id))
  }

  return (
    <div className="extra-specs">
      {rows.length === 0 ? (
        <p className="muted extra-specs__empty">추가된 항목이 없습니다.</p>
      ) : (
        <ul className="extra-specs__list">
          {rows.map((row) => (
            <li key={row.id} className="extra-specs__row">
              <input
                className="input"
                value={row.key}
                onChange={(event) => updateRow(row.id, 'key', event.target.value)}
                placeholder="항목명 (예: 입력전압)"
                aria-label="추가 사양 항목명"
              />
              <input
                className="input"
                value={row.value}
                onChange={(event) => updateRow(row.id, 'value', event.target.value)}
                placeholder="값 (예: 24VDC)"
                aria-label="추가 사양 값"
              />
              <button
                type="button"
                className="btn btn--ghost btn--touch"
                onClick={() => removeRow(row.id)}
                aria-label={`${row.key || '추가 사양'} 삭제`}
              >
                삭제
              </button>
            </li>
          ))}
        </ul>
      )}
      <button type="button" className="btn btn--ghost btn--touch extra-specs__add" onClick={addRow}>
        + 사양 추가
      </button>
    </div>
  )
}
